import Topnavbar from "../../../Layouts/Topnavbar";
import { Container, Grid, Paper, Text, Title, Group, ThemeIcon, Button} from "@mantine/core";
import React, { useState } from "react";
import {
    Table,
    Tag,
    Typography,
    Row,
    Col,
    DatePicker,
    Select,
    Input,
    Space,
    Card,
    Dropdown,
} from "antd";
import { MoreOutlined } from "@ant-design/icons";
const { Search } = Input;
const { RangePicker } = DatePicker;
const initialData = [
    {
        key: 1,
        requestId: "REQ100001",
        status: "Success",
        mode: "IMPS",
        utr: "UTR987654321",
        amount: 5000,
        fee: 10,
        netAmount: 4990,
        date: "24-Jun-2025 10:20 AM",
        remarks: "Amount Credited",
    },
    {
        key: 2,
        requestId: "REQ100002",
        status: "Pending",
        mode: "NEFT",
        utr: "UTR987654322",
        amount: 10000,
        fee: 20,
        netAmount: 9980,
        date: "24-Jun-2025 11:30 AM",
        remarks: "Processing",
    },
    {
        key: 3,
        requestId: "REQ100003",
        status: "Failed",
        mode: "RTGS",
        utr: "UTR987654323",
        amount: 2500,
        fee: 0,
        netAmount: 2500,
        date: "24-Jun-2025 01:15 PM",
        remarks: "Account Invalid",
    },
    {
        key: 4,
        requestId: "REQ100004",
        status: "Success",
        mode: "IMPS",
        utr: "UTR987654324",
        amount: 15000,
        fee: 25,
        netAmount: 14975,
        date: "25-Jun-2025 09:40 AM",
        remarks: "Completed",
    },
];



const Retailertrxnsummary = ({ Headername }) => {
    const [status, setStatus] = useState("all");
    const [utr, setUtr] = useState("");
    const [data, setData] = useState(initialData);

    const handleSearch = () => {
        let filtered = initialData;

        if (status !== "all") {
            filtered = filtered.filter(
                (item) => item.status.toLowerCase() === status
            );
        }

        if (utr) {
            filtered = filtered.filter((item) =>
                item.utr.toLowerCase().includes(utr.toLowerCase())
            );
        }

        setData(filtered);
    };

    const handleReset = () => {
        setStatus("all");
        setUtr("");
        setData(initialData);
    };

    const columns = [
        {
            title: "S.No.",
            dataIndex: "sno",
            width: 120,
        },
        {
            title: "Service Type",
            dataIndex: "servicetype",
            width: 120,
        },

        {
            title: "Amount",
            dataIndex: "amount",
            width: 120,
        },       
        {
            title: "Total Amount",
            dataIndex: "totalamount",
            // align: "right",
            // render: (amount) => `₹ ${amount.toLocaleString()}`,
        },
       
    ];
    return (
        <>
            <Topnavbar Headername={Headername} />
            <Container size={'xl'} mt={'sm'}>
                <Title c={'dimmed'}>Transaction Summary</Title>
                <Text size="xs">Verify your transaction in transaction summary</Text>
            </Container>

            <Container size={'lg'} mt={'lg'}>
                <Card title="Transaction History" style={{
                    width: "100%",
                }}>
                    <Row gutter={[16, 16]} style={{ marginBottom: 20 }}>
                        <Col xs={24} md={8}>
                            <RangePicker style={{ width: "100%" }} />
                        </Col>
                        <Col xs={24} md={4}>
                            <Select

                                // value={status}
                                // onChange={setStatus}
                                style={{ width: "100%" }}
                                options={[
                                    { label: "Service Type", value: "all" },
                                    { label: "Payout", value: "payout" },
                                    { label: "Aeps", value: "aesp" },
                                    { label: "Recharge", value: "recharge" },
                                    // { label: "Failed", value: "failed" },
                                ]}
                            />
                        </Col>
                        <Col xs={24} md={4}>
                            <Select
                                value={status}
                                onChange={setStatus}
                                style={{ width: "100%" }}
                                options={[
                                    { label: "All", value: "all" },
                                    { label: "Earned Comission", value: "earnedcomission" },
                                    { label: "Debit", value: "debit" },
                                    // { label: "Refunded", value: "refund" },
                                    // { label: "Pending", value: "pending" },
                                    // { label: "Failed", value: "failed" },
                                ]}
                            />
                        </Col>
                        <Col xs={24} md={6}>
                            <Space>
                            <Button type="primary">
                                    Search
                                </Button>
                                <Button variant="light">Reset</Button>
                                <Button type="secondary" variant="outline">
                                    Download
                                </Button>
                            </Space>
                        </Col>
                    </Row>

                    <div style={{ width: "100%", overflowX: "auto" }}>
                        <Table
                            columns={columns}
                            dataSource={data}
                            bordered
                            size="middle"
                            pagination={{
                                pageSize: 10,
                                showSizeChanger: true,
                            }}
                            // scroll={{ x: 1200 }}
                        />
                    </div>
                </Card>
            </Container>
        </>
    )
}
export default Retailertrxnsummary;